import { useState, useEffect } from "react";

const useDebounce = ( value, delay = 1500) => {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(()=>{
        const id = setTimeout(() => {
            console.log(value)
            setDebouncedValue(value)
        }, delay);

        return () => {
            clearTimeout(id);
        }
    },[value, delay])

    return debouncedValue;
}

export default useDebounce
